import React from 'react';
import { faSave } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const SubmitIcon = () => (
  <Icon tooltip="Submit" iconObj={faSave} />
);

export default SubmitIcon;